module.exports = __webpack_public_path__ + "static/img/preview-07.96a3cc90.webp";